var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.021,
    height: 40.024,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 17.51h25.018a5 5 0 015 5v12.511a5 5 0 01-5 5H5a5 5 0 01-5-5V22.513a5 5 0 015-5zm20.012 0z",
    fill: "#0063fb",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 17.51v-5a12.508 12.508 0 1125.015 0v5H5zm20.012-5v5H10.006v-5a7.505 7.505 0 1115.009 0z",
    fill: "#deebff",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 25.344a3.5 3.5 0 11-3.5 3.5 3.5 3.5 0 013.5-3.5z",
    fill: "#deebff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLock);
export default __webpack_public_path__ + "static/media/icon-lock.c2085ee0a483fa994f8dcf5aa1633296.svg";
export { ForwardRef as ReactComponent };